// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as Jwt from "../../externals/Jwt.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let storageItemKey = "jwt";

let isTesting = Env.context() === "test";

let testingStorageItemValue = {
  contents: isTesting ? "dummy-token" : undefined
};

function isImpersonated(jwt) {
  return Stdlib_Option.isSome(Json.flatDecodeDictFieldString(Json.flatDecodeDictField(Json.flatDecodeDictFieldDict(Stdlib_Option.flatMap(Jwt.decode(jwt), Json.decodeDict), "scope"), "impersonationUser", Json.decodeDict), "id"));
}

function get() {
  if (isTesting) {
    return testingStorageItemValue.contents;
  } else {
    return Stdlib_Option.orElse(Primitive_option.fromNull(sessionStorage.getItem(storageItemKey)), Primitive_option.fromNull(localStorage.getItem(storageItemKey)));
  }
}

function set(token, impersonating, param) {
  if (isTesting) {
    testingStorageItemValue.contents = token;
  } else if (impersonating === true) {
    sessionStorage.setItem(storageItemKey, token);
  } else {
    localStorage.setItem(storageItemKey, token);
  }
}

function remove() {
  if (isTesting) {
    testingStorageItemValue.contents = undefined;
  } else {
    sessionStorage.removeItem(storageItemKey);
    localStorage.removeItem(storageItemKey);
  }
}

export {
  storageItemKey,
  isTesting,
  testingStorageItemValue,
  isImpersonated,
  get,
  set,
  remove,
}
/* isTesting Not a pure module */
